import { defineEntitySource } from '@/shared/form/entity-source';
import { getCurrentTenant } from '@/shared/http/client';
import type * as Api from './user-group.api';
const listUserGroupOptions = async (...args: Parameters<typeof Api.listUserGroupOptions>) =>
  (await import('./user-group.api')).listUserGroupOptions(...args);
type Item<F extends (...args: never[]) => Promise<{ data: readonly unknown[] }>> = Awaited<
  ReturnType<F>
>['data'][number];
export function userGroupSource(tenant: string | undefined) {
  return defineEntitySource<Item<typeof listUserGroupOptions>>({
    key: ['user-group', 'source', 'user-group', tenant ?? ''],
    scope: () => tenant ?? getCurrentTenant(),
    search: async (query, signal) => {
      const groups = (await listUserGroupOptions({ tenant: tenant ?? getCurrentTenant() }, signal))
        .data;
      return query
        ? groups.filter((group) => group.groupName.toLowerCase().includes(query.toLowerCase()))
        : groups;
    },
    toOption: (group) => ({ value: group.groupName, label: group.groupName }),
  });
}

const searchUserGroupOptions = async (...args: Parameters<typeof Api.searchUserGroupOptions>) =>
  (await import('./user-group.api')).searchUserGroupOptions(...args);

/** Grupos do "Copiar permissões": busca no servidor por `searchString` (`ClonePermissionContainer.tsx:34`). */
export function userGroupSearchSource(tenant: string | undefined) {
  return defineEntitySource<Item<typeof searchUserGroupOptions>>({
    key: ['user-group', 'source', 'search', tenant ?? ''],
    scope: () => tenant ?? getCurrentTenant(),
    search: async (query, signal) =>
      (
        await searchUserGroupOptions(
          { tenant: tenant ?? getCurrentTenant(), searchString: query || undefined },
          signal,
        )
      ).data,
    toOption: (group) => ({ value: group.groupName, label: group.groupName }),
  });
}
